import React, {Component} from 'react';

export default class NoAccess extends Component {
  constructor(props) {
    super(props);

    this.state = {
    };
  }

  render() {
    const clicker = this.props.history ? this.props.history.goBack : null;
    return (
      <div className="alert alert-dismissible alert-warning">
      <button type="button" className="close" data-dismiss="alert">&times;</button>
      <h4 className="alert-heading">Oh, wow!</h4>
      <p className="mb-0">We're sorry, but you don't have access to that site. 
            If you're supposed to have access, you'll need to talk to somebody.
            <button onClick={clicker} 
              className="btn btn-link alert-link align-baseline">
              Best to go back, and maybe try again
            </button>
      </p>
      </div>
    );
  }
}
